<template>
  <v-card class="pa-4" flat>
    <div class="d-flex justify-end mb-4">
      <v-btn
        class="btn-delete rounded-lg"
        @click="
          goback = false;
          $emit('refresh');
        "
      >
        <v-icon small>mdi-arrow-right</v-icon>بازگشت
      </v-btn>
    </div>

    <message-list
      v-model="mlModel"
      :loading="addLoading"
      is-campaign
      @submit="addCamp"
    />
  </v-card>
</template>

<script>
import MessageList from "./messageList2.vue";
import { SmsAxios } from "@/main";

export default {
  name: "createCampaign",

  components: { MessageList },

  props: {
    value: Boolean,
  },

  data() {
    return {
      mlModel: [],
      addLoading: false,
    };
  },

  computed: {
    goback: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    addCamp(e) {
      this.addLoading = true;

      SmsAxios.post("campaign/store", e)
        .then(({ data }) => {
          this.$toast.success("کمپین با موفقیت ثبت شد");
          this.$emit("refresh");
          this.goback = false;
        })
        .catch(({ response }) => console.log("response: ", response))
        .finally(() => (this.addLoading = false));
    },
  },
};
</script>

<style scoped></style>
